import { FIELD_CLASS, LABEL_CLASS } from "./shared";

// SEO title/description overrides — only shown once a product exists (needs an id to save against).
export const SeoSection = ({ isNew, form, handleField }) => {
  if (isNew) return null;
  return (
    <div className="border border-[var(--border-default)] bg-[var(--bg-secondary)]/40 p-4 space-y-4">
      <p className="text-white/70 text-sm font-semibold">Search Engine (SEO) Settings</p>
      <label className="block">
        <span className={LABEL_CLASS}>SEO Title (leave blank to auto-generate from Name)</span>
        <input data-testid="admin-field-seo-title" value={form.seoTitle} onChange={(e) => handleField("seoTitle", e.target.value)} maxLength={70} className={FIELD_CLASS} />
        <p className="text-white/40 text-xs mt-1">{form.seoTitle.length}/70 characters</p>
      </label>
      <label className="block">
        <span className={LABEL_CLASS}>Meta Description (leave blank to auto-generate from Intro)</span>
        <textarea data-testid="admin-field-seo-description" rows={2} value={form.seoDescription} onChange={(e) => handleField("seoDescription", e.target.value)} maxLength={170} className={FIELD_CLASS} />
        <p className="text-white/40 text-xs mt-1">{form.seoDescription.length}/170 characters</p>
      </label>
    </div>
  );
};
